import { deleteAllAskInputDraftDatabases } from '#pplx/frontend/apps/ask/ask-input/ask-input-drafts/askInputDraftDatabase.js';
import { RECENT_WORKSPACE_DIRECTORIES_STORAGE_KEY, SELECTED_WORKSPACE_DIRECTORIES_STORAGE_KEY, } from '#pplx/frontend/apps/ask/ask-input/ask-input-types/index.js';
import { clearLocalSession } from '#pplx/frontend/apps/ask/auth/getSession.js';
import { clearPendingLoginAttempt } from '#pplx/frontend/apps/ask/auth/loginAttemptCorrelation.js';
import { resetIncognito } from '#pplx/frontend/apps/ask/incognito/useIncognito.js';
import { clearActiveQuery } from '#pplx/frontend/apps/ask/stores/queryInput.js';
import { USER_SETTINGS_PREFIX } from '#pplx/frontend/apps/ask/user-settings/storage/constants.js';
import { redirectAfterSignOut, resolveSignOutParams, signOut as nextAuthSignOut, } from '#pplx/frontend/auth/signOut.js';
import { clearActiveAccountId } from '#pplx/frontend/browser-storage/activeAccount.js';
import { clearLastActiveAccount } from '#pplx/frontend/browser-storage/lastActiveAccount.js';
import { SafeLocalStorage } from '#pplx/frontend/browser-storage/localStorage.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { isPushEnabled, disablePush } from '#pplx/frontend/push-notifications/pushNotifications.js';
import { rememberPushForRestore } from '#pplx/frontend/push-notifications/pushNotificationsRestore.js';
import { clearPersistedCache } from '#pplx/frontend/react-query/queryClient.js';
import { clearServiceWorkerRuntimeCache } from '#pplx/frontend/workers/service-worker/utils/clearServiceWorkerRuntimeCache.js';
async function clearCachesOnSignOut() {
    await clearPersistedCache();
    await clearServiceWorkerRuntimeCache();
}
async function clearLocalStateExceptSessionOnSignOut() {
    clearPendingLoginAttempt();
    if (!(await deleteAllAskInputDraftDatabases())) {
        logger.warn('signOut: failed to delete one or more Ask input draft databases');
    }
    resetIncognito();
    SafeLocalStorage.keys().forEach((key) => {
        if (key.startsWith(USER_SETTINGS_PREFIX)) {
            SafeLocalStorage.removeItem(key);
        }
    });
    SafeLocalStorage.removeItem(RECENT_WORKSPACE_DIRECTORIES_STORAGE_KEY, { global: true });
    SafeLocalStorage.removeItem(SELECTED_WORKSPACE_DIRECTORIES_STORAGE_KEY, { global: true });
    clearActiveQuery();
    // Reset multi-account identity (web): full sign-out clears every session cookie, so both this
    // tab's active-account pointer AND the cross-tab last-visible seed must go — otherwise the next
    // bootstrap would send `X-Pplx-Account` for a now-cookieless account (the pointer directly, or
    // the seed via `applyAccountFromLastActive`) and strand a fresh same-tab sign-in on the
    // logged-out screen.
    clearActiveAccountId();
    clearLastActiveAccount();
    try {
        if (await isPushEnabled())
            rememberPushForRestore();
        await disablePush({ reason: 'sign out' });
    }
    catch {
        // noop
    }
}
export async function clearEverythingOnSignOut() {
    await clearCachesOnSignOut();
    await clearLocalStateExceptSessionOnSignOut();
    clearLocalSession();
}
export const signOut = async (...args) => {
    const [options] = args;
    const { redirect, callbackUrl } = resolveSignOutParams(options);
    await clearCachesOnSignOut();
    await clearLocalStateExceptSessionOnSignOut();
    // Clearing cached session before this succeeds flips the UX to logged-out while cookies still auth.
    await nextAuthSignOut({ ...(options ?? {}), redirect: false, callbackUrl });
    clearLocalSession();
    if (!redirect) {
        return;
    }
    redirectAfterSignOut(callbackUrl);
};
//# sourceMappingURL=signOut.js.map